import { clearFilterParams } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../utils/apollo/api'
import LazySelectAllLinkApollo from '../../components/actions/LazySelectAllLinkApollo'

const QUERY = gql`
  query PlaceLevels($search: String, $filter: PlaceLevelFilter) {
    placeLevels(limit: 900000, search: $search, filter: $filter) {
      id
      type
      levelId
      parentId
    }
  }
`

const SelectAllPlaceLevelsLink = ({ search, filter, ...props }) => {
  return (
    <LazySelectAllLinkApollo
      query={QUERY}
      variables={{ search, filter: clearFilterParams(filter || {}) }}
      client={placesClient}
      {...props}
    />
  )
}

export default SelectAllPlaceLevelsLink
